import React, {useCallback, useEffect, useState} from "react";
import {deleteCert, updateCert} from "../../../../service/adminService";
import {Button, ButtonToolbar, Form, Modal, Stack} from "rsuite";
import {adminCertModel} from "../../../form/models";

const EditAdminCertModal = (props) => {
    const { open, handleClose, selectedCert } = props

    const [localState, setLocalState] = useState();

    useEffect(() => {
        setLocalState({...selectedCert});
    }, [selectedCert]);

    const submitCertEdit = (isFormValid) => {
        if(!isFormValid) return;
        updateCert(localState).then((response) => {
            handleClose(response);
        });
    };

    const submitCertDelete = useCallback(() => {
        deleteCert({id: localState.id}).then((response) => {
            handleClose(response);
        });
    }, [handleClose, localState]);

    // rsuite does not have an onSubmit, we must handle state changes per controlled field
    const handleFormChange = (event) => {
        setLocalState({...localState, ...event});
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            backdrop="static"
            size="md"
        >
            <Modal.Header>
                <Modal.Title>Edit Certificate</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Stack spacing={2} direction='column' alignItems='flex-start'>
                    <p>
                        Changes/removal will cascade to all users with this certificate
                    </p>
                    <p>
                        <b>Warning:</b> Deleting a certificate will remove it for all users with this current certificate.
                    </p>
                </Stack>
            </Modal.Body>
            <Form
                layout="horizontal"
                model={adminCertModel}
                onChange={handleFormChange}
                onSubmit={submitCertEdit}
                formDefaultValue={selectedCert}
            >
                <Form.Group>
                    <Form.ControlLabel>Cert Name</Form.ControlLabel>
                    <Form.Control
                        name="certName"
                        style={{width: 500}}
                    />
                </Form.Group>
                <Form.Group>
                    <ButtonToolbar>
                        <Button type="submit" appearance="primary">
                            Ok
                        </Button>
                        <Button onClick={handleClose} appearance="default">
                            Cancel
                        </Button>
                        <Button onClick={submitCertDelete} appearance="primary" color="red">
                            Delete Cert
                        </Button>
                    </ButtonToolbar>
                </Form.Group>
            </Form>
        </Modal>
    );
};


export default EditAdminCertModal;